var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 5.15039V7.92089",
    stroke: "#F2A93B",
    strokeWidth: 1.07742,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.99984 11.152C7.25485 11.152 7.46159 10.9453 7.46159 10.6903C7.46159 10.4352 7.25485 10.2285 6.99984 10.2285C6.74482 10.2285 6.53809 10.4352 6.53809 10.6903C6.53809 10.9453 6.74482 11.152 6.99984 11.152Z",
    stroke: "#F2A93B",
    strokeWidth: 1.07742,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.82187 1.50242C7.74437 1.35115 7.62663 1.2242 7.48161 1.13555C7.33659 1.04691 7.16992 1 6.99996 1C6.82999 1 6.66332 1.04691 6.5183 1.13555C6.37328 1.2242 6.25554 1.35115 6.17804 1.50242L1.09879 11.6609C1.02795 11.8015 0.994221 11.9579 1.00081 12.1152C1.0074 12.2724 1.05408 12.4254 1.13644 12.5596C1.21879 12.6938 1.33407 12.8047 1.47133 12.8817C1.60859 12.9588 1.76328 12.9995 1.92071 13H12.0792C12.2366 12.9995 12.3913 12.9588 12.5286 12.8817C12.6658 12.8047 12.7811 12.6938 12.8635 12.5596C12.9458 12.4254 12.9925 12.2724 12.9991 12.1152C13.0057 11.9579 12.972 11.8015 12.9011 11.6609L7.82187 1.50242Z",
    stroke: "#F2A93B",
    strokeWidth: 1.07742,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeWarningIcon);
export default __webpack_public_path__ + "static/media/OrangeWarningIcon.3f17a6c9a9d96b9f795c76e4867a3cc5.svg";
export { ForwardRef as ReactComponent };